import { type WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { useCallback } from "react";

import { type WorkerRequirement } from "../Documents/api/types";
import { useGetCheckrApplicationStatus } from "../Documents/Details/Workflows/Checkr/useGetCheckrApplicationStatus";
import { filterOutBackgroundCheckRequirements } from "./filterOutBackgroundCheckRequirements";
import { useGetRunBackgroundCheckOnBookingConfiguration } from "./useGetRunBackgroundCheckOnBookingConfiguration";

interface FilterOptions {
  status?: WorkerRequirementStatus[];
}

export function useFilterBackgroundCheckRequirements() {
  const {
    isEnabled: isBackgroundCheckOnBookingEnabled,
    autoShiftUnassignmentValidityWindowInDays,
  } = useGetRunBackgroundCheckOnBookingConfiguration();

  const { data: checkrStatus, isLoading } = useGetCheckrApplicationStatus({
    enabled: isBackgroundCheckOnBookingEnabled,
  });

  const filterOutBackgroundCheckOnlyIfNotAutoUnassigned = useCallback(
    (requirements: WorkerRequirement[], filter?: FilterOptions): WorkerRequirement[] => {
      if (isBackgroundCheckOnBookingEnabled) {
        return filterOutBackgroundCheckRequirements({
          autoShiftUnassignmentValidityWindowInDays,
          workerRequirements: requirements,
          filter: {
            status: filter?.status,
            onlyIfNotAutoUnassigned: true,
          },
          ...(isDefined(checkrStatus?.data?.autoShiftUnassignmentAt)
            ? { autoShiftUnassignmentAt: checkrStatus.data.autoShiftUnassignmentAt }
            : {}),
        });
      }

      return requirements;
    },
    [
      autoShiftUnassignmentValidityWindowInDays,
      checkrStatus?.data?.autoShiftUnassignmentAt,
      isBackgroundCheckOnBookingEnabled,
    ]
  );

  return {
    filterOutBackgroundCheckOnlyIfNotAutoUnassigned,
    isLoading,
  };
}
